export const validateStyle = (style: string | number) => {
  if (!style && style !== 0) {
    return false;
  }
  if (style === "default") {
    return false;
  }
  return true;
};
